const StepsHeader = ({ steps, onStepClick }) => (
<div className="steps-header">
    <div className="steps-container">
      {steps.map((step) => (
        <div
          key={step.id}
          className={`step-item ${step.completed ? "completed" : ""} ${
            step.active ? "active" : ""
          }`}
          onClick={() => onStepClick && onStepClick(step.id)}
          role="button"
          aria-current={step.active ? "step" : undefined}
          aria-label={`Step ${step.id}: ${step.label}`}
          tabIndex={0}
        >
          <span className="step-number">
            {step.completed ? "" : step.id}
          </span>
          <span className="step-label">{step.label}</span>
        </div>
      ))}
    </div>
  </div>
);

export default StepsHeader;
